var _style, _polygon, _polygon2, _path, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypLogoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230 110",
    style: {
      enableBackground: "new 0 0 230 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#001A4C;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "101.1,21 90.5,50.1 90.5,50.1 79.9,21 59.4,21 80.3,78.3 68.7,110 89.3,110 90.5,106.6 100.8,78.3  121.7,21 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "55.4,41.5 47.9,21 38,21 38,0.5 17.4,0.5 17.4,21 0,21 7.5,41.5 17.4,41.5 17.4,89.5 38,89.5 38,41.5  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.8,21.3c-6.6-0.9-13,0.1-18.5,2.5c-12.1,5.3-20.5,17.3-20.5,31.4V110h20.5V86.6c4.2,1.8,8.8,2.9,13.7,2.9 c20.1,0,36.2-17.3,34-37.9C188.4,36.1,176.1,23.5,160.8,21.3z M155.9,68.9c-7.6,0-13.7-6.1-13.7-13.7s6.1-13.7,13.7-13.7 c7.6,0,13.7,6.1,13.7,13.7C169.6,62.8,163.5,68.9,155.9,68.9z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "199.4,82.8 217.6,89.4 230,55.2 217.5,21 217.5,21 199.4,27.6 209.5,55.2 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypLogoBlue);
export default __webpack_public_path__ + "static/media/typ-logo-blue.241e5e25.svg";
export { ForwardRef as ReactComponent };